import { render } from "./setrecordmodel.vue?vue&type=template&id=7fbf7cb2"
import script from "./setrecordmodel.vue?vue&type=script&lang=ts"
export * from "./setrecordmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script